import { render, staticRenderFns } from "./Programador.vue?vue&type=template&id=795430a0"
import script from "./Programador.vue?vue&type=script&lang=js"
export * from "./Programador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports